export default __webpack_public_path__ + "static/media/after_payment.11a0fb41.png";